import { render } from "./Leaves.vue?vue&type=template&id=9bf87854"
import script from "./Leaves.vue?vue&type=script&lang=js"
export * from "./Leaves.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__